
    <div
      *ngIf="!standalone"
      class="form-group"
    >
      <div class="d-flex d-flex-gap">
        <fieldmagic-text
          *ngIf="displayLabel || (label | filled)"
          purpose="input"
          [content]="label"
          [withRequiredMarker]="withRequiredMarker"
        >
        </fieldmagic-text>

        <fieldmagic-icon
          *ngIf="tooltip | filled"
          icon="info-circle"
          [tooltip]="tooltip"
        >
        </fieldmagic-icon>
      </div>
      <ng-container *ngTemplateOutlet="inputTmp"></ng-container>
    </div>
    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="inputTmp"
    >
    </ng-container>
    <ng-template #inputTmp>
      <ng-select
        #myInput
        placeholder="{{ placeholder | translate }}"
        class="fieldmagic-dropdown"
        [class.fieldmagic-input-has-error]="errors | filled"
        [disabled]="isDisabled$ | async"
        [items]="options$ | async"
        [clearable]="clearable"
        [typeahead]="typeahead$"
        [loading]="searching$ | async"
        [(ngModel)]="value"
        (change)="onChanged($event)"
        (click)="onTouched()"
        [multiple]="multi"
        [groupBy]="makeGroupNameFactory()"
        bindLabel="text"
        [bindValue]="bindValue"
        appendTo="body"
        [isOpen]="isOpen$ | async"
        [groupValue]="makeGroupValueFactory()"
        (blur)="onBlur()"
      >
        <!-- displayed for the selected dropdown option -->
        <ng-template
          ng-label-tmp
          let-item="item"
          let-clear="clear"
        >
          <span class="ng-value-label">{{
            computeDisplay(item) | translate
          }}</span>
          <span
            *ngIf="multi"
            class="ng-value-icon right selected-close"
            (click)="clear(item)"
          >
            x
          </span>
        </ng-template>

        <!-- displayed for the dropdown options -->
        <ng-template
          ng-option-tmp
          let-item="item"
        >
          <fieldmagic-indent
            *ngIf="(item.is_parent | filled) && !item.is_parent"
          >
            <span>{{ computeDisplay(item) | translate }}</span>
          </fieldmagic-indent>

          <span *ngIf="(item.is_parent | blank) || item.is_parent">{{
            computeDisplay(item) | translate
          }}</span>
        </ng-template>

        <ng-template
          ng-optgroup-tmp
          let-item="item"
        >
          <ng-container *ngIf="optionGroupTmp | blank">
            {{ item | data_get : 'text' | translate }}
          </ng-container>

          <ng-container
            *ngIf="optionGroupTmp | filled"
            [ngTemplateOutlet]="optionGroupTmp"
            [ngTemplateOutletContext]="{
              item: item
            }"
          ></ng-container>
        </ng-template>

        <!-- displayed for results found: only when customizable is enabled -->
        <ng-template
          let-searchTerm="searchTerm"
          ng-notfound-tmp
        >
          <span
            *ngIf="(customizable$ | async) && (searchTerm | filled)"
            class="ng-option"
            (click)="onNewCustomizedOption(searchTerm)"
          >
            {{ 'Add new item for "%s"' | translate | sprintf : [searchTerm] }}
          </span>

          <span
            *ngIf="searchTerm | blank"
            class="ng-option disabled"
            [innerText]="'No items found' | translate"
          >
          </span>
        </ng-template>
      </ng-select>
      <fieldmagic-input-errors
        *ngIf="errors | filled"
        [errors]="errors"
      ></fieldmagic-input-errors>
    </ng-template>
  